<template>  
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-container grid-list-xl fluid>
        <v-layout row>
          <v-flex xs12 v-if="skeletonLoading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
          </v-flex>
          <v-flex xs12 md12 v-else>
            <form @submit.prevent="onsubmit">          
              <v-card>                    
                <v-toolbar flat dense :color="jilid.color ? jilid.color : 'cyan'" dark>
                  <v-toolbar-title>{{jilid.name}}</v-toolbar-title>
                  <v-spacer />
                  <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
                </v-toolbar>
                <v-card-text>
                  <p><strong>Description -</strong> {{jilid.description}}</p>           
                  <v-layout row wrap>
                    <v-flex xs6 md3>
                      <v-autocomplete
                        v-model="fm.responden_id"
                        :items="siswas"
                        :loading="siswaLoading"
                        @keyup="searchSiswa"
                        chips
                        clearable                      
                        hide-selected
                        item-text="nama"
                        item-value="id"
                        label="Search for Siswa"  
                        :error="!!error.responden_id.length"
                        :error-messages="error.responden_id"                                              
                      >
                        <template v-slot:no-data>
                          <v-list-tile>
                            <v-list-tile-title>
                              Search for 
                              <strong>Siswa</strong>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                        <template v-slot:selection="{ item, selected }">
                          <v-chip
                            :selected="selected"
                            color="blue-grey"
                            class="white--text"
                          >
                            <v-icon left>mdi-coin</v-icon>
                            <span v-text="item.nama"></span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-tile-avatar
                            :color="getColor(item.tingkat_id)"
                            class="headline font-weight-light white--text"
                          >
                            {{ item.nama ? item.nama.charAt(0):'' }}
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{item.nama}} - {{item.calonGedung.number}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{tingkats.find(x=>x.id === item.tingkat_id).nama}}, TTL : {{item.lahir_tempat}} {{$moment(item.lahir_tanggal).format('DD/MM/YY')}}</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon>mdi-coin</v-icon>
                          </v-list-tile-action>
                        </template>
                      </v-autocomplete> 
                      
                      <v-menu
                        v-model="datepicker"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field outlined dense
                            v-model="fm.date"
                            label="Date"
                            append-icon="event"
                            readonly
                            v-on="on"
                            style="width:150px"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="fm.date" @input="datepicker = false"></v-date-picker>
                      </v-menu>
                                                                                  
                    </v-flex> 
                    <v-flex xs12 md9 v-if="siswa && siswa.id">
                      <v-layout row wrap>
                        <v-flex xs12 md4>
                          <v-avatar size="200" style="float:right">
                            <img :src="$config.file+'user-image?reff_id='+siswa.user_id">
                          </v-avatar>
                        </v-flex>
                        <v-flex xs12 md8>
                          <table>
                            <tr class="title"><td>Nama Lengkap</td><td>:</td><td>{{siswa.nama}} ({{genders[siswa.gender]}})</td></tr>
                            <tr><td>Tingkat</td><td>:</td><td>{{tingkats.find(x=>x.id==siswa.tingkat_id)?tingkats.find(x=>x.id==siswa.tingkat_id).nama:''}}</td></tr>
                            <tr v-if="siswa.jurusan_id"><td>Jurusan</td><td>:</td><td>{{tingkats.find(x=>x.id==siswa.jurusan_id)?tingkats.find(x=>x.id==siswa.jurusan_id).nama:''}}</td></tr>
                            <tr><td>Tempat/Tgl Lahir</td><td>:</td><td>{{siswa.lahir_tempat}}, {{$moment(siswa.lahir_tanggal).format('DD/MM/YYYY')}}</td></tr>                          
                            <tr><td>Sekolah Asal</td><td>:</td><td>{{siswa.sekolah_nama}}</td></tr>
                            <tr><td>Nama Ayah</td><td>:</td><td>{{siswa.ayah_nama}}</td></tr>
                            <tr><td>Pekerjaan Ayah</td><td>:</td><td>{{siswa.ayah_pekerjaan}}</td></tr>
                            <tr><td>Penghasilan Ayah</td><td>:</td><td>{{siswa.ayah_penghasilan}}</td></tr>
                            <tr><td>Nama Ibu</td><td>:</td><td>{{siswa.ibu_nama}}</td></tr>
                            <tr><td>Pekerjaan Ibu</td><td>:</td><td>{{siswa.ibu_pekerjaan}}</td></tr>
                            <tr><td>Penghasilan Ibu</td><td>:</td><td>{{siswa.ibu_penghasilan}}</td></tr>
                          </table>                          
                        </v-flex>
                      </v-layout>                      
                    </v-flex>                   
                  </v-layout>
                </v-card-text>  
                <v-toolbar :color="jilid.color ? jilid.color : 'cyan lighten-4'" flat dark dense>
                  <h3>Questionnaire</h3><v-spacer/>              
                </v-toolbar>
                <v-card-text>
                  <table>
                    <template v-for="(quetion, i) in fm.responDtls">
                      <tr :key="i">
                        <td valign="top" class="text-center body-1">{{quetion.no}}.</td>
                        <td valign="top">
                          <p><span class="body-1">{{quetion.question}}</span><br/>
                            <template v-if="quetion.type === 1">
                              <div class="mb-4 mt-2">
                                <template v-for="(opt,n) in quetion.option">
                                  <input :key="n" type="radio" v-model="quetion.answer_id" :value="opt.id" class="mr-2" /> <span :key="n+'span'" @click="quetion.answer_id=opt.id">{{opt.key+'. '+opt.value}}</span> <br :key="n+'br'" />                    
                                </template>
                              </div>
                              <!--<v-radio-group v-model="quetion.answer_id" hide-details class="mt-0">
                                <v-radio v-for="(opt,n) in quetion.option" :key="n"
                                  :label="opt.key+'. '+opt.value" :value="opt.id"
                                ></v-radio>
                              </v-radio-group>-->
                            </template>
                            <template v-else-if="quetion.type === 2">
                              <v-checkbox v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonid[n]" :key="n" class="mt-1" :label="opt.key+'. '+opt.value" :value="opt.id" hide-details></v-checkbox>            
                            </template>
                            <template v-else-if="quetion.type === 3">
                              <v-text-field v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonvalue[n]" :key="n" type="text" :label="opt.key" small hide-details style="max-width:400px;margin-bottom:4px;" >
                                <span :set="quetion.answer_jsonkey[n] = opt.key"></span>
                              </v-text-field>
                            </template>
                          </p>
                        </td>
                      </tr>
                    </template>
                  </table>              
                </v-card-text>
                <v-card-actions class="pa-4">
                  <v-spacer />
                  <v-btn @click="onsubmit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
                </v-card-actions>
              </v-card>
            </form>   
          </v-flex>            
        </v-layout>
      </v-container>  
    </div>
  </v-slide-y-transition>      
</template>

<script>
import { debounce } from 'lodash'
import model from '@/apps/admin/models/master/Respon'

export default {
  data : () => ({  
    fm:{ 
      responden_id:null, jilid_id: null, code: null, date:null, name: null, phone:null, gender:null, tps_id:null, address:null, geom:null,
      addr_idpro:null, addr_idkab: null, addr_idkec:null, addr_idkel:null, image:null, responDtls:[]
    },
    error:{ 
      responden_id:[], jilid_id: [], code: [], date:[], name: [], phone:[], gender:[], tps_id:[], address:[], geom:[],
      addr_idpro: [], addr_idkab: [], addr_idkec:[], addr_idkel:[], image:[], responDtls:[]
    },
    jilid:{},
    headers: [
      {text:'No', value:'no', width:70},
      {text:'Key', value:'key', width:180},
      {text:'Value', value:'value'},
      {text:'', value:'action', width:50, sortable:false},
    ],
    disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
    provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
    provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
    siswas : [], siswaLoading : false, siswa:{},    

    items:[],
    loading: false,
    isUpdate: false,  
    datepicker: false,  
    mode: 0,        
    nodes: [], nodeLoading:false,
    colorpicker:false,
    skeletonLoading:false,
    tingkats : [],
  }),
  computed:{
    genders(){
      return {1:'L', 2:'P'};
    }
  },
  watch:{
    'fm.addr_idpro'(newId){if(newId){      
      model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
      })
    }},
    'fm.addr_idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{this.fm.addr_idpro = data.parent_id;})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
      }
    },
    'fm.addr_idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    },   
    'fm.addr_idkel'(newId, oldId){if(oldId===null && newId !== null){
      this.tpsLoading = true;
      model.node({id:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(data=>{
        this.kelurahan.push(data); 
        model.tps({idkel:data.id, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{
          this.tps = res.data;
          this.tpsLoading = false;
        })
      })  
    } else if(this.kelurahan.find(x=>x.id===newId)){
      this.tpsLoading = true;
      model.tps({idkel:newId, jilid_id:this.jilid.id, expand:'lembar,lembarDone'}).then(res=>{
        this.tps = res.data;
        this.tpsLoading = false;
      })
    }},
    'fm.responden_id'(newId){      
      this.siswa = this.siswas.find(x=>x.id==newId);      
      if(newId && (!this.siswa)){
        model.calons({'UserCalonSearch[id]':newId}).then(res=>{
          this.siswas = res.data;
          if(res.data[0]){
            this.siswa = res.data[0];
          }
        });
      } else if(!newId){
        this.siswa = {};
      }
    }
  }, 
  mounted(){
    this.fm.date = this.$moment().format('YYYY-MM-DD');
    
    if(this.$route.query.jilid_id){
      this.skeletonLoading = true;
      this.fm.jilid_id = this.$route.query.jilid_id;  
      model.jilid({id:this.fm.jilid_id, expand:'quetionnaires'}).then(data=>{
        Object.assign(this.jilid, data);        
        if(this.jilid.node_id){
          model.node({id:this.jilid.node_id}).then(res=>{
            if(res.level){
              switch(parseInt(res.level)){
                case 1: this.fm.addr_idpro = res.id; 
                  this.disabled.addr_idpro = true;
                  break;
                case 2: this.fm.addr_idkab = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  break;
                case 3: this.fm.addr_idkec = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  this.disabled.addr_idkec = true;
                  break;
                case 4: this.fm.addr_idkel = res.id; 
                  this.disabled.addr_idpro = true;
                  this.disabled.addr_idkab = true;
                  this.disabled.addr_idkec = true;
                  this.disabled.addr_idkel = true;
                  break;
              }
            }            
          })
        }      
        if(this.$route.query.id){
          this.isUpdate = true; this.skeletonLoading = true;
          model.view({id:this.$route.query.id, expand:'responDtls'}).then(data=>{
            this.skeletonLoading = false;                
            Object.assign(this.fm, JSON.parse(JSON.stringify(data)));                
            this.fm.area_id = String(this.fm.area_id);
            if(!this.fm.jilid_id){
              this.$router.replace({name:'survey'});
              return;
            }
            if(Array.isArray(this.jilid.quetionnaires) && Array.isArray(this.fm.responDtls)){              
              this.jilid.quetionnaires.forEach(item=>{
                let question = this.fm.responDtls.find(x=>x.quetionnaire_id == item.id);
                if(question){
                  question.jilid_id = this.jilid.id;
                  question.no = item.no;
                  question.type = item.type;
                  question.question = item.question;
                  question.option = item.option;                    
                } else {
                  this.fm.responDtls.push({
                    quetionnaire_id:item.id,
                    jilid_id:this.jilid.id,
                    no:item.no,
                    type:item.type,
                    question:item.question,
                    option:item.option,
                    answer_id:null,
                    answer_key:null,
                    answer_value:null,
                    answer_jsonid:[],
                    answer_jsonkey:[],
                    answer_jsonvalue:[]
                  })
                }                
              });
            }
          })
        } else {
          if(!this.fm.jilid_id){
            this.$router.replace({name:'survey'});
            return;
          }
          if(Array.isArray(this.jilid.quetionnaires)){
            this.jilid.quetionnaires.forEach(item=>{
              this.fm.responDtls.push({
                quetionnaire_id:item.id,
                jilid_id:this.jilid.id,
                no:item.no,
                type:item.type,
                question:item.question,
                option:item.option,
                answer_id:null,
                answer_key:null,
                answer_value:null,
                answer_jsonid:[],
                answer_jsonkey:[],
                answer_jsonvalue:[]
              })
            });
          }          
        }   
        this.skeletonLoading = false;
      })   
    }  
    
    model.tingkats().then(data=>{this.tingkats = data;});
  },
  methods: {
    searchSiswa: debounce(function(e){
      this.siswaLoading = true;
      model.calons({
        'UserCalonSearch[nama]':e.target.value,
        expand : 'calonGedung'
      }).then(res=>{
        this.siswas = res.data;
        this.siswaLoading = false;
      });      
    }, 400),

    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
    },

    search: debounce(function (e) {      
      this.readNodes(e.target.value)
    }, 800),

    readNodes(term){
      this.nodeLoading = true;
      model.nodes({q:term,level:this.fm.tingkat}).then(res=>{
        this.nodes = res.data;
        this.nodeLoading = false;
      })
    },
    
    addQuetion(){      
      let no = this.fm.quetionnaires.length + 1;
      this.fm.quetionnaires.push({no:no, question:null, type:1, option:[]})
    },

    delQuetion(i){
      this.fm.quetionnaires.splice(i, 1);
    },

    addOption(quetion){
      quetion.option.push({id:null, key:null, value: null});
    },

    delOption(quetion, item){
      quetion.option.splice(quetion.option.findIndex(x=>x===item), 1);
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();      
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res){
        if(res.status === 200){
          window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
          this.$router.replace({name:'tes/survey/respon', query:this.$route.query})                
        } else {
          this.validate(res.data);
        }
      } else {
        this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                                    
        this.$router.replace({name:'tes/survey/respon', query:this.$route.query})                
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
.v-data-table-header-mobile__wrapper .v-select {
    max-width:200px !important;
}
</style>